<lib-card [fullScreenMode]="true" [fullHeight]="true" (fullScreenChange)="onCardFullScreenChanged($event)">
  <lib-card-header>
    <div class="row d-flex bd-highlight">
      <div class="col-7 mr-auto pt-0 bd-highlight">
        <lib-content-box-buttons
          [type]="'link'"
          [buttons]="buttons"
          [counts]="counts"
          [active]="active"
          (activeChanged)="changeTab($event)">
        </lib-content-box-buttons>
      </div>
      <div class="col-5 p-0 bd-highlight">
        <lib-content-box-buttons
          [active]="label"
          [buttons]="options"
          (activeChanged)="handleAlarmTypeChange($event)">
        </lib-content-box-buttons>
      </div>
    </div>
  </lib-card-header>
  <lib-card-body [fullContent]="true">
    <div id="alarms">
      @if (source === 'alarms') {
        @if (!alarms) {
          <div class="row d-flex justify-content-around mt-2 mb-4">
            <div>
              <app-spinner></app-spinner>
            </div>
          </div>
        }
        <app-alarms-table
          [alarms]="alarms"
          [isExpanded]="isCardExpanded"
          >
        </app-alarms-table>
      }
      @if (source === 'cms') {
        @if (!cmsAlarms) {
          <div class="row d-flex justify-content-around mt-2 mb-4">
            <div>
              <app-spinner></app-spinner>
            </div>
          </div>
        }
        <app-alarms-cms-table [alarms]="cmsAlarms"></app-alarms-cms-table>
      }
    </div>
  </lib-card-body>
</lib-card>